export class CommunicationLogParticipant {
    constructor(public id: number, public displayname: string) { }
}